module.exports = __webpack_public_path__ + "static/media/distrito_b-01.5223e582.svg";